import React from 'react';
import { PortfolioList } from 'Portfolio';

require('./stylesheets/IndexComponent.scss');

import Welcome from './Welcome';
import Skills from './Skills';

const IndexComponent = (props) => (
  <div>
    <Welcome />
    <Skills />
    <div className="row">
      <h2 className="center-text">Portfolio.</h2>
      <PortfolioList data={ props.data } />
    </div>
  </div>
);

export default IndexComponent;




// WEBPACK FOOTER //
// ./app/src/Home/components/IndexComponent.js